module.exports = "<div class=\"loading-view\" *ngIf=\"isLoading\"></div>\r\n"